import { Pagination, Row } from "antd"
import { forwardRef, useImperativeHandle, useState } from "react"
import { Drawer, Icon, Spinner, Title } from ".."

export const DrawerWithCustomContent = forwardRef(
  (
    {
      totalCount,
      withPagination = true,
      pageSizeOptions,
      extraOptionsOnPageChange = null,
      isFetching,
      title = "",
      renderCustomContent = () => {},
      onChangePage = () => {},
    },
    ref
  ) => {
    const [showCallsDrawer, setShowCallsDrawer] = useState(false)
    const defaultPageSize = pageSizeOptions?.[0] || 20
    const [page, setPage] = useState(1)
    const [pageSizeSave, setPageSize] = useState(defaultPageSize)

    const toggleDrawer = () => {
      setPage(1)
      setPageSize(defaultPageSize)
      setShowCallsDrawer(prev => !prev)
    }

    useImperativeHandle(ref, () => ({ toggleDrawer }))

    const onHandleChange = (page, pageSize) => {
      setPage(page)
      setPageSize(pageSize)
      onChangePage(page - 1, pageSize, extraOptionsOnPageChange)
    }

    return (
      <Drawer
        title={
          <Title level={3} className="mbe-0">
            {title}
          </Title>
        }
        headerStyle={{ paddingBlock: 20 }}
        closable={false}
        width={700}
        onClose={toggleDrawer}
        open={showCallsDrawer}
        extra={<Icon icon="IoMdClose" onClick={toggleDrawer} />}
        destroyOnClose={true}
        footer={
          withPagination && (
            <Row justify="end">
              <Pagination
                onChange={onHandleChange}
                pageSizeOptions={pageSizeOptions}
                pageSize={pageSizeSave}
                defaultCurrent={page}
                current={page}
                total={totalCount}
                showSizeChanger
                size="small"
                disabled={isFetching}
              />
            </Row>
          )
        }
      >
        {isFetching ? <Spinner fullPageSpinner /> : <>{renderCustomContent()}</>}
      </Drawer>
    )
  }
)
